// 账户详情 --> 批次号 --> 账户详情 请求参数
export const EXAMINE_TABLE_QUERY = {
  receiptNumber: '', // 批次号
  siteId: 0, // 网点id
  name: '' // 网点名称
};

